export default "__VITE_ASSET__7VBoT3Vo__"